import { render, staticRenderFns } from "./addCertSt.vue?vue&type=template&id=2770c728&scoped=true&"
import script from "./addCertSt.vue?vue&type=script&lang=js&"
export * from "./addCertSt.vue?vue&type=script&lang=js&"
import style0 from "./addCertSt.vue?vue&type=style&index=0&id=2770c728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2770c728",
  null
  
)

export default component.exports